module.exports = __webpack_public_path__ + "static/img/3.46317da.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/9/eng/3.png
// module id = KfpI
// module chunks = 0